// TODO waiting payload from backend
export enum GamesFilterTypeEnum {
  Recommended = 'recommended',
  Popularity = 'popularity',
  New = 'new',
  RTP = 'rtp',
  NameAsc = 'name_asc',
  NameDesc = 'name_desc',
}

export const GamesFilterOptions = [
  {
    key: GamesFilterTypeEnum.Recommended,
    value: 'Recommended',
  },
  {
    key: GamesFilterTypeEnum.Popularity,
    value: 'Popularity',
  },
  {
    key: GamesFilterTypeEnum.New,
    value: 'New',
  },
  {
    key: GamesFilterTypeEnum.RTP,
    value: 'RTP',
  },
  {
    key: GamesFilterTypeEnum.NameAsc,
    value: 'Name A - Z',
  },
  {
    key: GamesFilterTypeEnum.NameDesc,
    value: 'Name Z - A',
  },
]

export type GameFilterOptionType = {
  key: GamesFilterTypeEnum
  value: string
}
